import { Jobs } from "../apis/jobs";
import { globalStore } from "../state/store";
import Atlas from "./atlas";
import { metrics } from "./tracking";
import "core-js/stable/promise";
import "regenerator-runtime";
var $ = require("jquery");
require('./../css/style.css');
export const atlas = new Atlas("map-container");
var jobsDataAtlas = [];
var subset = [];
var listenladestand = {};
var jobs_index_on_pillar = [];
var jobs_grid_index_on_pillar = [];
var jobs_list_index_on_pillar = [];
var jobs_popupgrid_index_on_pillar = [];
atlas.map.on('moveend', onMoveEndAtlas);
function onMoveEndAtlas() {
    atlas.filterJobsOnMap(atlas.getExtent()).then((value) => { return; });
    if (!atlas.isSpotlightVisible()) {
        $('#indicator_map').fadeIn(350);
    }
    else {
        $('#indicator_map').fadeOut(350);
    }
}
atlas.map.on('pointermove', function (e) {
    if (e.dragging)
        return;
    var pixel = e.map.getEventPixel(e.originalEvent);
    var hit = atlas.map.hasFeatureAtPixel(e.pixel, {
        layerFilter: function (layer) {
            return layer.get("name") === 'cluster';
        }
    });
    e.map.getTargetElement().style.cursor = hit ? 'pointer' : '';
});
atlas.subscribe(["STATE_CHANGE_ALLJOBS"], (state) => {
});
atlas.subscribe(["STATE_CHANGE_VISIBLEJOBS"], (state) => {
    var anzahl = state.visibleJobs.length;
    if (typeof window.stellenanzeige_aktualisieren === 'function') {
        window.stellenanzeige_aktualisieren(anzahl);
    }
    liste_aktualisieren_visible('#grid', '#grid div', '#grid');
    liste_aktualisieren_visible('#tabelle_stellen', '#tabelle_stellen tr', '#stellen_liste');
});
atlas.subscribe(["STATE_CHANGE_SELECTEDLOCATION"], (state) => {
    handleClick(atlas, state.selectedJobs, state.selectedLocation);
});
atlas.subscribe(["STATE_CHANGE_JOBLOCATIONS"], (state) => {
});
const showJobs = (jobs) => {
    if (jobs[0].score === 0) {
        if (jobs.length == 1) {
            window.AbroadElements.JobPopup.showJob(jobs[0].id);
        }
        else {
            Marker_Click_Atlas(jobs);
        }
    }
    else {
        onGoMatchMarkerClick(jobs);
    }
};
const handleClick = (atlas, job, loc) => {
    let visibleJobs = globalStore.getState().allJobs;
    if (process.env.TEST_DISPLAY_ALWAYS === "true") {
    }
    else {
        let coordinates = [];
        let lat, lon;
        for (let j = 0; j < loc.length; j++) {
            lon = parseFloat(loc[j].lng);
            lat = parseFloat(loc[j].lat);
            coordinates.push([lon, lat]);
        }
        if (loc.length > 1) {
            let jobs = [];
            for (let i = 0; i < loc.length; i++) {
                for (let j = 0; j < visibleJobs.length; j++) {
                    if (loc[i].IDs.indexOf(visibleJobs[j].id.toString()) != -1) {
                        jobs.push(visibleJobs[j]);
                    }
                }
            }
            showJobs(jobs);
        }
        else {
            let jobids = loc[0].IDs;
            let jobs = [];
            for (let i = 0; i < visibleJobs.length; i++) {
                if (jobids.indexOf(visibleJobs[i].id.toString()) != -1) {
                    jobs.push(visibleJobs[i]);
                }
            }
            showJobs(jobs);
            if (!loc[0].IDs.includes(",")) {
            }
        }
    }
};
export function setNewJobs(url, data) {
    new Jobs(url).getFromRawData(data).then((jobs) => {
        globalStore.dispatch("setJobs", jobs[0]);
        globalStore.dispatch("setJobLocation", jobs[1]);
    });
}
export function setNewGoMatch(url, data) {
    new Jobs(url).getFromGoMatchRawData(data).then((jobs) => {
        globalStore.dispatch("setJobs", jobs[0]);
        globalStore.dispatch("setJobLocation", jobs[1]);
        globalStore.dispatch("setSelectedGeometries", []);
    });
}
export function setAddressSpotlight(address, radius) {
    atlas.radiusSearch(address, radius).then((value) => { return; });
}
function Marker_Click_Atlas(jobs) {
    $('#kartenpopup').fadeIn(350);
    jobsDataAtlas = jobs;
    subset = [];
    jobsDataAtlas.forEach(element => subset.push(element.id));
    liste_aktualisieren('#kartenpopup_grid', '#kartenpopup_grid div', '#kartenpopup_grid', subset);
    window.blurBackground();
}
function onGoMatchMarkerClick(jobs) {
    window.AbroadElements.MatchingResultPopup.show(jobs);
}
export function liste_aktualisieren_visible(id, muster, scrollmaster) {
    jobsDataAtlas = atlas.getVisibleJobs();
    subset = [];
    jobsDataAtlas.forEach(element => subset.push(element.id));
    liste_aktualisieren(id, muster, scrollmaster, subset);
}
function liste_aktualisieren(id, muster, scrollmaster, subset) {
    var table = $(id);
    $(muster + '[Job_ID]').remove();
    listenladestand[id] = {
        'doneCount': 0,
        'subset': subset
    };
    liste_mehr_laden_atlas(id, muster, scrollmaster);
}
export function liste_mehr_laden_atlas(id, muster, scrollmaster) {
    var master = $(muster).first();
    var table = $(id);
    var pane = $(scrollmaster);
    var subset = listenladestand[id].subset;
    var done = listenladestand[id].doneCount;
    var paneHeight = pane.innerHeight();
    if (paneHeight <= 0)
        return;
    if (pane[0].scrollHeight <= 0)
        return;
    var minOffset = (1.5 * paneHeight) + pane.scrollTop();
    var maxOffset = (2 * paneHeight) + pane.scrollTop();
    if (!(done < subset.length && pane[0].scrollHeight <= minOffset)) {
        return;
    }
    var seen_jobs = {};
    var seen_jobs_index = [];
    var newjobs_index_on_pillar = [];
    var seen_jobs_grid_index = [];
    var seen_jobs_list_index = [];
    var seen_jobs_popupgrid_index = [];
    var newjobs_popupgrid_index_on_pillar = [];
    var newjobs_grid_index_on_pillar = [];
    var newjobs_list_index_on_pillar = [];
    while (done < subset.length && pane[0].scrollHeight <= maxOffset) {
        var job = jobsDataAtlas[done];
        var clone = master.clone(true);
        clone.find('.datum').text(job.date);
        clone.find('.firma').text((job.corp == null) ? "Firma s. Ausschreibung" : job.corp);
        clone.find('.titel').text(job.title);
        clone.find('a.titel').on('click', function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            window.AbroadElements.JobPopup.showJob(this.getAttribute('data-content-name'));
        });
        clone.find('a.titel').removeAttr('href');
        clone.find('a.titel').attr("target", '_blank');
        clone.find('a.titel').attr("data-track-content");
        clone.find('a.titel').attr("data-content-target", job.url);
        if (scrollmaster == "#grid") {
            clone.find('a.titel').attr("data-content-piece", 'Grid');
        }
        else if (scrollmaster == '#stellen_liste') {
            clone.find('a.titel').attr("data-content-piece", 'Liste');
        }
        else if (scrollmaster == '#kartenpopup_grid') {
            clone.find('a.titel').attr("data-content-piece", 'Karte Popup-Grid');
        }
        clone.find('a.titel').attr("data-content-name", job.id);
        clone.find('.logo img').attr("src", job.logo);
        clone.attr("id", id.substring(1) + "_" + job.id);
        clone.attr("Job_ID", job.id);
        clone.find('.tabelle_vergroessern').css('display', 'none');
        clone.css('display', '');
        table.append(clone);
        if (scrollmaster == '#grid') {
            seen_jobs_grid_index.push(job.id);
        }
        else if (scrollmaster == '#stellen_liste') {
            seen_jobs_list_index.push(job.id);
        }
        else if (scrollmaster == '#kartenpopup_grid') {
            seen_jobs_popupgrid_index.push(job.id);
        }
        seen_jobs[job.id] = {
            'jobID': job.id,
            'layout': scrollmaster
        };
        seen_jobs_index.push(job.id);
        done++;
    }
    newjobs_index_on_pillar = diff_seen_jobs(jobs_index_on_pillar, seen_jobs_index);
    if (scrollmaster == '#grid') {
        newjobs_grid_index_on_pillar = diff_seen_jobs(jobs_grid_index_on_pillar, seen_jobs_grid_index);
    }
    else if (scrollmaster == '#stellen_liste') {
        newjobs_list_index_on_pillar = diff_seen_jobs(jobs_list_index_on_pillar, seen_jobs_list_index);
    }
    else if (scrollmaster == '#kartenpopup_grid') {
        newjobs_popupgrid_index_on_pillar = diff_seen_jobs(jobs_popupgrid_index_on_pillar, seen_jobs_popupgrid_index);
    }
    var newjobs = newjobs_index_on_pillar.length + newjobs_grid_index_on_pillar.length + newjobs_list_index_on_pillar.length + newjobs_popupgrid_index_on_pillar.length;
    if (newjobs > 0) {
        send_jobs_on_pillar(seen_jobs, newjobs_index_on_pillar, newjobs_grid_index_on_pillar, newjobs_list_index_on_pillar, newjobs_popupgrid_index_on_pillar);
    }
    jobs_index_on_pillar = merge_seen_jobs(jobs_index_on_pillar, seen_jobs_index);
    jobs_grid_index_on_pillar = merge_seen_jobs(jobs_grid_index_on_pillar, seen_jobs_grid_index);
    jobs_list_index_on_pillar = merge_seen_jobs(jobs_list_index_on_pillar, seen_jobs_list_index);
    jobs_popupgrid_index_on_pillar = merge_seen_jobs(jobs_popupgrid_index_on_pillar, seen_jobs_popupgrid_index);
    listenladestand[id].doneCount = done;
}
function diff_seen_jobs(a1, a2) {
    var a = [], b = [], diff = [];
    if (a2.length == 0) {
        return a1;
    }
    else {
        for (var i = 0; i < a1.length; i++) {
            a[a1[i]] = true;
        }
        for (var i = 0; i < a2.length; i++) {
            if (a[a2[i]]) {
                delete a[a2[i]];
            }
            else {
                b.push(a2[i]);
                a[a2[i]] = 'true';
            }
        }
        return b;
    }
}
function send_jobs_on_pillar(jobs, index, index_grid, index_list, index_popupgrid) {
    var sendjobs = [];
    var sendjobs_grid = [];
    var sendjobs_list = [];
    var sendjobs_popupgrid = [];
    var sendjobs_visited = [];
    var sendjobs_visited_grid = [];
    var sendjobs_visited_popupgrid = [];
    var sendjobs_visited_list = [];
    for (var i = 0; i < index.length; i++) {
        var layout = jobs[index[i]]['layout'];
        var jobID = jobs[index[i]]['jobID'];
        if (layout == '#grid') {
            sendjobs_grid.push(jobID);
        }
        else if (layout == '#stellen_liste') {
            sendjobs_list.push(jobID);
        }
        else if (layout == '#kartenpopup_grid') {
            sendjobs_popupgrid.push(jobID);
        }
    }
    for (var i = 0; i < index_grid.length; i++) {
        var jobID = jobs[index_grid[i]]['jobID'];
        sendjobs_visited_grid.push(jobID);
    }
    for (var i = 0; i < index_popupgrid.length; i++) {
        var jobID = jobs[index_popupgrid[i]]['jobID'];
        sendjobs_visited_popupgrid.push(jobID);
    }
    for (var i = 0; i < index_list.length; i++) {
        var jobID = jobs[index_list[i]]['jobID'];
        sendjobs_visited_list.push(jobID);
    }
    var ts = new Date();
    var modified = ts.toJSON();
    var url = location.protocol + "//" + location.host + "/srv.php/API2/";
    var start = '{"calls":[{"call":"log",';
    var end = '}]}';
    if (sendjobs_grid.length + sendjobs_list.length > 0) {
        sendjobs = sendjobs_grid.length > 0 ? sendjobs.concat(start + '"layout": "new_grid", "modified": "' + modified + '", "jobs": [' + sendjobs_grid + ']' + end) : sendjobs.concat(start + '"layout": "new_list", "modified": "' + modified + '", "jobs": [' + sendjobs_list + ']' + end);
        var xhr = new XMLHttpRequest();
        xhr.open("POST", url, true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(sendjobs.toString());
    }
    if (sendjobs_visited_grid.length + sendjobs_visited_list.length + sendjobs_popupgrid.length > 0) {
        sendjobs_visited = sendjobs_visited_grid.length > 0 ? sendjobs_visited.concat(start + '"layout": "visited_grid", "modified": "' + modified + '", "jobs": [' + sendjobs_visited_grid + ']' + end) : sendjobs_visited.concat(start + '"layout": "visited_list", "modified": "' + modified + '", "jobs": [' + sendjobs_visited_list + ']' + end);
        var xhr = new XMLHttpRequest();
        xhr.open("POST", url, true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(sendjobs_visited.toString());
        for (var i = 0; i < sendjobs_list.length; i++) {
            window._paq.push(['trackContentImpression', sendjobs_list[i], 'Liste']);
        }
        for (var i = 0; i < sendjobs_grid.length; i++) {
            window._paq.push(['trackContentImpression', sendjobs_grid[i], 'Grid']);
        }
        for (var i = 0; i < sendjobs_popupgrid.length; i++) {
            window._paq.push(['trackContentImpression', sendjobs_popupgrid[i], 'Karte Popup-Grid']);
        }
    }
}
function merge_seen_jobs(a1, a2) {
    var args = arguments;
    var hash = [];
    var arr = [];
    for (var i = 0; i < args.length; i++) {
        for (var j = 0; j < args[i].length; j++) {
            if (hash[args[i][j]] !== true) {
                arr[arr.length] = args[i][j];
                hash[args[i][j]] = true;
            }
        }
    }
    return arr;
}
const startButton = document.getElementById("start");
const stopButton = document.getElementById("stop");
startButton === null || startButton === void 0 ? void 0 : startButton.addEventListener("click", () => {
    metrics.reset();
    startButton.innerText = "Reset";
});
atlas.map.on("click", () => {
    metrics.addClick();
});
stopButton === null || stopButton === void 0 ? void 0 : stopButton.addEventListener("click", () => {
    metrics.stop();
    alert("Bitte den untenstehenden Text kopieren\n\n" + metrics.getResult());
    console.log(metrics.getResult());
    startButton.innerText = "Start";
});
